<ion-header mode="ios" class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tabs/home" text=""></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content scrollY="true">
  <ng-container *ngIf="!loading else showLoading">
    <div class="ion-padding">
      <div class="hero-holder campaign-update">
        <div class="hero-bg"></div>
        <div class="hero-content">
          <div class="hero-header">
            <span class="date">{{campaignDetail?.publish_date | dateTranslate:'longMonth':language}}</span>
            <h1 [innerHTML]="campaignDetail?.title"></h1>
            <h2 class="tag" [innerHTML]="campaignDetail?.subtitle" [ngClass]="{small: !language.includes('en')}"></h2>
            <h2 class="tag second-tag" [ngClass]="{small: !language.includes('en')}">
              {{ 'IMPACT.publicisCampaignUpdate.engagement' | translate}}
            </h2>
          </div>

          <div class="campaign-explanation">
            <ion-icon name="heart"></ion-icon>
            <div
              [innerHTML]="'IMPACT.publicisCampaignUpdate.support-note' | translate : {counter: publicisCampaign?.attributes?.supporters_number}"
            ></div>
          </div>
        </div>
      </div>
      <div class="campaign-content">
        <div>
          <h2>{{ 'IMPACT.publicisCampaignUpdate.content-1.title' | translate}}</h2>
          <p>{{ 'IMPACT.publicisCampaignUpdate.content-1.p' | translate : {counter: publicisCampaign?.attributes?.supporters_number} }}</p>
          <a href="https://inyova.ch/wp-content/uploads/2023/01/230113-Inyova-letter-to-Publicis-.pdf" target="_blank" class="pdf-link">
            {{ 'IMPACT.publicisCampaignUpdate.content-1.link' | translate }}
          </a>
        </div>
        <div>
          <h2>{{ 'IMPACT.publicisCampaignUpdate.content-2.title' | translate}}</h2>
          <p>{{ 'IMPACT.publicisCampaignUpdate.content-2.p' | translate }}</p>
        </div>
        <div class="timeline-holder">
          <h2 class="green">{{ 'IMPACT.publicisCampaignUpdate.timeline.title' | translate}}</h2>
          <ul>
            <li *ngFor="let index of [1,2,3,4,5,6];">
              <p class="date-label">{{ ('IMPACT.publicisCampaignUpdate.timeline.list.item-'+index+'.title') | translate}}</p>
              <p [innerHTML]="('IMPACT.publicisCampaignUpdate.timeline.list.item-'+index+'.p') | translate"></p>
            </li>
          </ul>
          <button class="support-button" (click)="shareCampaign()">
            {{ 'IMPACT.publicisCampaign.button.invite.finished' | translate}}
          </button>
        </div>
      </div>
    </div>
    <div class="related-article" *ngIf="publicisCampaign">
      <div class="ion-padding">
        <h3>{{'IMPACT.publicisCampaignUpdate.relatedCampaign.title' | translate}}</h3>
        <app-impact-stories-item
          [language]="language"
          [item]="publicisCampaign"
          (openDetail)="openDetail(publicisCampaign?.id)"
        ></app-impact-stories-item>
      </div>
    </div>
  </ng-container>
  <ng-template #showLoading>
    <div class="ion-padding">
      <ion-skeleton-text animated class="date"></ion-skeleton-text>
      <ion-skeleton-text animated class="image-holder"></ion-skeleton-text>
      <ion-skeleton-text animated></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 75%"></ion-skeleton-text>
    </div>
  </ng-template>
</ion-content>
